import { render, staticRenderFns } from "./ThemeSwitch.vue?vue&type=template&id=aa46328c&scoped=true"
import script from "./ThemeSwitch.vue?vue&type=script&lang=ts"
export * from "./ThemeSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ThemeSwitch.vue?vue&type=style&index=0&id=aa46328c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa46328c",
  null
  
)

export default component.exports